import { useState, useEffect } from "react";
import { ActiveFarmContext } from "./context";

export const ActiveFarmProvider = ({ children }) => {
  // Initialize state from localStorage using lazy initialization
  const [activeFarm, setActiveFarm] = useState(() => {
    const storedActiveFarm = localStorage.getItem("activeFarm");
    if (storedActiveFarm) {
      try {
        return JSON.parse(storedActiveFarm);
      } catch {
        return null;
      }
    }
    return null;
  });

  // Save activeFarm to localStorage whenever it changes
  useEffect(() => {
    if (activeFarm !== null) {
      localStorage.setItem("activeFarm", JSON.stringify(activeFarm));
    }
  }, [activeFarm]);

  return (
    <ActiveFarmContext.Provider value={{ activeFarm, setActiveFarm }}>
      {children}
    </ActiveFarmContext.Provider>
  );
};
